import * as React from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { CONSTANTS as styleConstants } from '../../styles/styleConstants';
import { AbstractAudioView, AudioViewStyleProp } from './AbstractAudioView';

export enum PlaybackState {
    Paused,
    Playing
}

interface IProps {
    source: string;
    audioRef(element: HTMLAudioElement | null): void;
    playbackState: PlaybackState;
    onPlay?(event: Event): void;
    onPause?(event: Event): void;
    onLoadedMetadata?(event: Event): void;
    onListen(currentTime: number): void;
    listenIntervalMs: number;
    showCancelConfirm?: boolean;
    isComment: boolean;
    manageButtonContainerStyle?: AudioViewStyleProp;
}

export class AudioPlayer extends AbstractAudioView<IProps> {
    public render() {
        return (
            <div style={this.props.style || styles.container}>
                <ReactAudioPlayer
                    src={this.props.source}
                    ref={element => {
                        if (element) {
                            this.props.audioRef(element.audioEl);
                        }
                    }}
                    onPlay={this.props.onPlay}
                    onPause={this.props.onPause}
                    onListen={this.props.onListen}
                    onLoadedMetadata={this.props.onLoadedMetadata}
                    listenInterval={this.props.listenIntervalMs}
                />

                <div style={{ ...styles.buttonContainer, ...this.props.buttonContainerStyle }}>
                    {this.props.playbackState === PlaybackState.Paused ? this.renderStartButton() : this.renderPauseButton()}
                    {this.renderStopButton()}
                </div>
                <div style={styles.progressContainer}>{this.renderProgress()}</div>
                {this.props.showCancelConfirm && !this.props.isComment && (
                        <div style={this.getStyleObjectFromProp(this.props.manageButtonContainerStyle)}>
                            {this.renderCancelButton()}
                            {this.renderConfirmButton()}
                        </div>
                    )}
            </div>
        );
    }
}

const styles: { [index: string]: React.CSSProperties } = {
    buttonContainer: { display: styleConstants.FLEX, flexDirection: styleConstants.flexDirection.ROW, width: 200 },
    progressContainer: { display: styleConstants.FLEX, flex: 1 },
    container: {
        display: styleConstants.FLEX,
        flexDirection: styleConstants.flexDirection.ROW,
        justifyContent: styleConstants.flexJustify.SPACE_BETWEEN,
        paddingTop: 30,
        paddingRight: 20
    },
    flexRow: {},
    fullWidth: { width: '100%' }
};



// WEBPACK FOOTER //
// ./src/_components/AudioRecorder/AudioPlayer.tsx